import { render, staticRenderFns } from "./FocusAlignmentSlide.vue?vue&type=template&id=70ff55d8&scoped=true&"
import script from "./FocusAlignmentSlide.vue?vue&type=script&lang=js&"
export * from "./FocusAlignmentSlide.vue?vue&type=script&lang=js&"
import style0 from "./FocusAlignmentSlide.vue?vue&type=style&index=0&id=70ff55d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff55d8",
  null
  
)

export default component.exports